<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="5"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <p class="ys_bk">交易额统计明细</p>
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="eventName" label="栏目名称"></el-table-column>
                    <el-table-column prop="total" label="栏目营收合计"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import { API_YHJYMIX } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: '',
            dialog: false,
            name: '',
            wxName: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_YHJYMIX, params, (res) => {
                this.listData = res.data.data
            })
        }
    }
}
</script>
  
<style lang="less">
.ys_bk{
    font-size: 16px;
    margin-bottom: 20px;
    font-weight: 700;
}
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

</style>


// WEBPACK FOOTER //
// src/pages/glyJyemx/index.vue